import React from 'react'
import cx from 'classnames'
import MenuLink from 'components/layout/MenuLink'
import useMenu from 'hooks/useMenu'
import selectHeaderMenu from 'redux/selectors/selectHeaderMenu'
import AolSelectorDesktop from './AolSelectorDesktop'

const Menu = ({ pageId, className }) => {
  const menuItems = useMenu(selectHeaderMenu)

  return (
    <nav
      data-help-item='menu'
      data-help-position='bottom'
      className={cx('pt6 dn-t flex layout-width-constraint', className)}
    >
      <AolSelectorDesktop />
      {menuItems.map((item, key) => (
        <MenuLink key={key} {...item} currentPageId={pageId} />
      ))}
    </nav>
  )
}

export default Menu
